export default {"src":"/_next/static/media/Featured icon.55ea0fad.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};